import React from 'react'

import { formatCurrency, formatNumber } from '../../lib/format-number'
import { getDmp, getDmpProduct } from '../../lib/format-dmps'

const SummaryRevenueRow = ({ property }) => (
    <tr className="revenue-list revenue-list--header">
        <td className="revenue-list revenue-list--property">{getDmp(property.market)}</td>
        <td className="revenue-list revenue-list--property ">{getDmpProduct(property.dmpProductId)}</td>
        <td className="revenue-list revenue-list--revenue">{formatNumber(property.impressions)}</td>
        <td className="revenue-list revenue-list--revenue">{formatCurrency(property.revenueGross, property.currency)}</td>
        <td className="revenue-list revenue-list--revenue">{formatCurrency(property.revenueNet, property.currency)}</td>
    </tr>
)

export default SummaryRevenueRow
